import Joi from 'joi';
import { actionCreator, objectSchemaOf } from '../helpers';

export const SNAPSHOT = 'VISION/SNAPSHOT';

interface ISnapshotActionPayload {
  conversationId: string;
  faceId?: string;
}

const snapshotActionPayloadSchema = objectSchemaOf<ISnapshotActionPayload>({
  conversationId: Joi.string().required(),
  faceId: Joi.string().optional(),
});

export const snapshotActionSchema = objectSchemaOf<ISnapshotAction>({
  type: Joi.string().required().valid(SNAPSHOT),
  payload: snapshotActionPayloadSchema.required(),
});

export interface ISnapshotAction {
  type: typeof SNAPSHOT;
  payload: ISnapshotActionPayload;
}

export const snapshot = actionCreator({
  type: SNAPSHOT,
  schema: snapshotActionSchema,
});
